import React, { Component, useState } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem 
} from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useNavigate, matchPath, useParams, useLocation } from 'react-router-dom';

import JegyeladasContent from './JegyeladasContent';
import Loader from '../../../commons/loader';
import Lib from "../../../commons/lib";

const JegyeladasBase = (props) => {

  const {
      globals,
      changePortalData,
      dismissPortal,
    } = props;

    const { eventId, rendelesId } = useParams();
    const { l } = useLocation();


    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Helyszíni értékesítés
              {/* <YouTube data={videoData} /> */}
            </div>
            <div style={cardStyle}>
              <div className="col-md-12">
            {globals.keycloak.authenticated ?
              <JegyeladasContent
                {...props}
                l={l}
                globals={globals}
                changePortalData={changePortalData}
                dismissPortal={dismissPortal}
                eventId={eventId}
                rendelesId={rendelesId}
              />
            : <Loader />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

JegyeladasBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default JegyeladasBase;
